// Frontend mirror of api/src/lib/authz.py. Used only for UI gating (hiding
// actions/nav a user can't perform); the API is the source of truth and
// re-checks every request.

export type Role = 'admins' | 'sales-engineers' | 'support';

export const ROLE_LABELS: Record<Role, string> = {
  admins: 'Admin',
  'sales-engineers': 'Sales Engineer',
  support: 'Support',
};

export const ROLE_OPTIONS: { value: Role; label: string }[] = [
  { value: 'admins', label: 'Admin' },
  { value: 'sales-engineers', label: 'Sales Engineer' },
  { value: 'support', label: 'Support' },
];

export type Permission =
  | 'tenants:read'
  | 'tenants:write'
  | 'tenants:delete'
  | 'devices:read'
  | 'devices:provision'
  | 'devices:delete'
  | 'team:read'
  | 'team:manage'
  | 'billing:manage';

const ALL_PERMISSIONS: Permission[] = [
  'tenants:read', 'tenants:write', 'tenants:delete',
  'devices:read', 'devices:provision', 'devices:delete',
  'team:read', 'team:manage', 'billing:manage',
];

export const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  admins: ALL_PERMISSIONS,
  'sales-engineers': [
    'tenants:read', 'tenants:write', 'devices:read', 'devices:provision', 'team:read',
  ],
  support: ['tenants:read', 'devices:read', 'team:read'],
};

export function permissionsForRoles(roles: string[]): Set<Permission> {
  const perms = new Set<Permission>();
  for (const r of roles) {
    const list = ROLE_PERMISSIONS[r as Role];
    if (list) list.forEach((p) => perms.add(p));
  }
  return perms;
}

export function primaryRole(roles: string[]): string {
  for (const r of ['admins', 'sales-engineers', 'support'] as Role[]) {
    if (roles.includes(r)) return ROLE_LABELS[r];
  }
  return 'No role';
}
